import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {Community} from "../../models/community.model";
import {PageModel} from "../../models/page.model";
import {ApiRoutesService} from "../api-routes.service";
import {SortDirection} from "@angular/material/sort";
import {Hardware} from "../../models/hardware.model";
import {CommunitySubscription} from "../../models/community-subscription.model";

@Injectable({
  providedIn: 'root'
})
export class AdminCommunityService {

  readonly #httpClient = inject(HttpClient);
  readonly #apiRoutes = inject(ApiRoutesService);

  public findAll(page: number, pageSize: number, search: string, sort: string, direction: SortDirection): Observable<PageModel<Community>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)
      .set('sort', sort)
      .set('direction', direction);

    return this.#httpClient.get<PageModel<Community>>(this.#apiRoutes.community(true), {params});
  }

  public findOne(communityId: string): Observable<Community> {
    return this.#httpClient.get<Community>(`${this.#apiRoutes.community(true)}/${communityId}`);
  }

  public createCommunity(data: any, profilePicture: File | null): Observable<Community> {
    const formData = new FormData();
    formData.append('community', new Blob([JSON.stringify(data)], {type: 'application/json'}));

    if (profilePicture) {
      formData.append('file', profilePicture, profilePicture.name);
    }

    return this.#httpClient.post<Community>(this.#apiRoutes.community(true), formData);
  }

  public findByCommunityId(communityId: string): Observable<Hardware> {
    return this.#httpClient.get<Hardware>(`${this.#apiRoutes.community()}/${communityId}/hardwares`);
  }

  public toggleStatus(communityId: string, active:boolean): Observable<Community> {
    return this.#httpClient.patch<Community>(`${this.#apiRoutes.community(true)}/${communityId}`, {"active":active});
  }

  public deleteCommunity(communityId: string): Observable<any> {
    return this.#httpClient.delete(`${this.#apiRoutes.community(true)}/${communityId}`);
  }

  public changeHardware(communityId: string, hardwareId: string): Observable<any> {
    return this.#httpClient.put<any>(`${this.#apiRoutes.community(true)}/${communityId}/hardwares/${hardwareId}`, {});
  }

  public removeHardware(communityId: string): Observable<void> {
    return this.#httpClient.delete<void>(`${this.#apiRoutes.community(true)}/${communityId}/hardwares`);
  }

  public updateCommunitySubscription(communityId: string, communitySubscription: CommunitySubscription): Observable<any> {
    return this.#httpClient.put<any>(`${this.#apiRoutes.community(true)}/${communityId}/subscriptions/${communitySubscription.id}`, communitySubscription);
  }

  public removeMember(communityId: string, profileId: string) {
    return this.#httpClient.delete(`${this.#apiRoutes.community(true)}/${communityId}/members/${profileId}`);
  }
}
